import React, { useEffect } from 'react';
import WarningIcon from '@material-ui/icons/Warning';
import { styles } from './styles';
import { logoutMakeTokenInactive } from '@carrier-sce-sharedpackages/auth-module';
import { umAuthConfig } from 'configuration';
export default function UnauthorizedView() {
  const classes = styles();
  useEffect(() => {
    const logoutUser = () => {
      const token = localStorage.getItem('msal.idtoken');
      sessionStorage.clear();
      localStorage.removeItem('msal.idtoken');
      logoutMakeTokenInactive(umAuthConfig, false, token);
    };

    const timer = setTimeout(logoutUser, 3000);
    // Cleanup function to clear timeout if the component unmounts
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={classes.root}>
      <div>
        <WarningIcon className={classes.iconWarning} />
      </div>
      <div className={classes.txtMessage}>
        {`Logging Out. You're unauthorized now!`}
      </div>
    </div>
  );
}
